export default __webpack_public_path__ + "static/media/LANDING1.7c4f60c8.jpg";